import {preloadImages, preloadFonts, clamp, map, randomNumber} from '../utils';
// import Cursor from '../cursor';
import LocomotiveScroll from 'locomotive-scroll';

// Se agregan eventos de hover y click a las imagenes de los temas.
let menuBtns = document.querySelectorAll('.menu-btn');
let themeImg = document.querySelectorAll('.gallery__item-img');
let hamburguerItems = document.querySelectorAll('.hamburguer-item');

menuBtns.forEach(el => {
    el.addEventListener('click', (e) => {
        e.preventDefault();

        let tema;
        el.href.includes('nosotros') ? tema = 'nosotros.html' : tema = 'contacto.html';

        document.querySelector('body').classList.add('out-animation');
        setTimeout(() => {
            location.href += tema;
        }, 1000);
    })
});

//Se agregan eventos click a los items del menu scroll
themeImg.forEach(el => {
    
    el.addEventListener('mouseover', (e) => {
        let themeImgImg = el.children[0].children[0].children[0];
        let themelist = el.children[0].children[0].children[1];
        themeImgImg.style.transform = 'scale(1.15) translate(15px)'
        themeImgImg.style.filter = 'opacity(30%)'
        themelist.style.filter = 'opacity(100%)'
        themelist.style.transform = 'translate(55px)'
    })
    el.addEventListener('mouseout', (e) => {
        let themeImgImg = el.children[0].children[0].children[0];
        let themelist = el.children[0].children[0].children[1];
        themeImgImg.style.transform = 'scale(1.3) translate(0px)'
        themeImgImg.style.filter = 'opacity(100%)'
        themelist.style.filter = 'opacity(0%)'
        themelist.style.transform = 'translate(0px)'

    })

    el.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector('body').classList.add('out-animation');
        setTimeout(() => {
            let tema = el.dataset.theme

            switch (tema) {
            case 'impresion':
                location.href = 'impresion.html'
                break;
            case 'avisos':
                location.href = 'avisos.html'
                break;
            case 'web':
                location.href = 'web.html'
                break;
            case 'promocionales':
                location.href = 'promocionales.html'
                break;
            case 'imagen':
                location.href = 'imagen_corporativa.html'
                break;
            case 'rigidos':
                location.href = 'impresion_de_rigidos.html'
                break;
            case 'porta':
                location.href = 'porta-pendones.html'
                break;
            case 'carnets':
                location.href = 'carnets.html'
                break;
            case 'senalizacion':
                location.href = 'senalizacion.html'
                break;
            case 'diseno':
                location.href = 'diseno.html'
                break;
            case 'socialmedia':
                location.href = 'socialmedia.html'
                break;
            }
        }, 1000);
    })
});

//Se agregan eventos click a los items del menu hamburguesa
hamburguerItems.forEach(el => {

    el.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector('body').classList.add('out-animation');
        setTimeout(() => {
            let tema = el.dataset.theme

            switch (tema) {
            case 'impresion':
                location.href = 'impresion.html'
                break;
            case 'avisos':
                location.href = 'avisos.html'
                break;
            case 'web':
                location.href = 'web.html'
                break;
            case 'promocionales':
                location.href = 'promocionales.html'
                break;
            case 'imagen':
                location.href = 'imagen_corporativa.html'
                break;
            case 'rigidos':
                location.href = 'impresion_de_rigidos.html'
                break;
            case 'porta':
                location.href = 'porta-pendones.html'
                break;
            case 'carnets':
                location.href = 'carnets.html'
                break;
            case 'senalizacion':
                location.href = 'senalizacion.html'
                break;
            case 'diseno':
                location.href = 'diseno.html'
                break;
            case 'socialmedia':
                location.href = 'socialmedia.html'
                break;
            case 'nosotros':
                location.href = 'nosotros.html'
                break;
            case 'contacto':
                location.href = 'contacto.html'
                break;
            }
        }, 1000);
    })
});

//trancicion inicial del home
document.addEventListener('DOMContentLoaded', () => {
    
    const $homeImg = document.querySelector('.img-fondo');
    const $tope = document.querySelector('.tope');
    $homeImg.classList.add('img-fondo-end');

    $tope.classList.add('tope-animation')
    $tope.style.width = '20vw';
    setTimeout(() => {
        document.querySelector('body').setAttribute('transition-style', '');
    }, 1000);
    setTimeout(() => {
        $tope.style.width = '50vw';
    }, 700);
})

if (window.innerWidth <= 700) {

    // Se agrega estilos en linea al svg "IMPRESION" en linea
    document.querySelector('#Ebene_1').style.margin = '0 auto';
    document.querySelector('#Ebene_1').style.fontSize = '5rem';

    let $home = document.querySelector('.home'),
        $imgFondo = document.querySelector('.img-fondo'),
        $menu = document.querySelector('.container-menu')
    window.addEventListener('scroll', (e) => {
        if (document.documentElement.scrollTop < 200) {
            $imgFondo.style.filter = 'blur(0px)';
            $home.style.filter = 'blur(0px)';
            $menu.style.filter = 'blur(0px)';
        }
        if (document.documentElement.scrollTop > 200) {
            $imgFondo.style.filter = 'blur(7px)';
            $home.style.filter = 'blur(7px)';
            $menu.style.filter = 'blur(7px)';
        }
    });
}


if (window.innerWidth > 700) {
    let $scrollContainer = document.querySelector('.scroll-container'),
        $imgFondo = document.querySelector('.img-fondo');
    window.addEventListener('scroll', (e) => {
        // if (document.documentElement.scrollTop < 400) {
        //     $imgFondo.style.filter = 'blur(0px)';
        //     $home.style.filter = 'blur(0px)';
        // }
        // if (document.documentElement.scrollTop > 400) {
        //     $imgFondo.style.filter = 'blur(10px)';
        //     $home.style.filter = 'blur(10px)';
        // }
        console.log($scrollContainer.scrollLeft);
        console.log(window.scrollY);
    });


    const lscroll = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        direction: 'horizontal',
    });
    
    // let's rotate the elements when scrolling.
    const elems = [...document.querySelectorAll('.gallery__item')]
    const rotationsArr = Array.from({length: elems.length}, () => randomNumber(-30,30));
    const translationArr = Array.from({length: elems.length}, () => randomNumber(-100,100));
    lscroll.on('scroll', (obj) => {
        for (const key of Object.keys(obj.currentElements)) {
            const el = obj.currentElements[key].el;
            const idx = elems.indexOf(el);
            if ( obj.currentElements[key].el.classList.contains('gallery__item') ) {
                let progress = obj.currentElements[key].progress;
                //const scaleVal = progress < 0.5 ? clamp(map(progress,0,0.5,1.2,0.5),0.5,1.2) : clamp(map(progress,0.5,1,0.5,1.2),0.5,1.2);
                const rotationVal = progress > 0.35 ? clamp(map(progress,0.35,1,0,rotationsArr[idx]), Math.min(0,rotationsArr[idx]), Math.max(0,rotationsArr[idx])) : 0;
                const translationVal = progress > 0.35 ? clamp(map(progress,0.35,1,0,translationArr[idx]), Math.min(0,translationArr[idx]), Math.max(0,translationArr[idx])) : 0;
                //obj.currentElements[key].el.style.transform = `scale(${scaleVal})`
                obj.currentElements[key].el.style.transform = `translateY(${translationVal}%) rotate(${rotationVal}deg)`
            }
        }
    });
    lscroll.update();
    
    // Preload images and fonts
    Promise.all([preloadImages('.gallery__item-imginner .home .home-img .img-fondo'), preloadFonts('vxy2fer')]).then(() => {
        // Remove loader (loading class)
        document.body.classList.remove('loading');
    
        // Initialize custom cursor
        // const cursor = new Cursor(document.querySelector('.cursor'));
    
        // Mouse effects on all links and others
        // [...document.querySelectorAll('a,.gallery__item-img,.gallery__item-number')].forEach(link => {
        //     link.addEventListener('mouseenter', () => cursor.enter());
        //     link.addEventListener('mouseleave', () => cursor.leave());
        // });
    });

    function onScroll({ scroll, limit, velocity, direction, progress }) {
        console.log(scroll, limit, velocity, direction, progress);
    }
    
    
    // Se desplaza automaticamente el scroll horizontal al inicio de la carga.
    let scrollContainer = document.querySelector('[data-scroll-container]')
    scrollContainer.scrollTop = '1000';
    
}
